import React from 'react'
import styled from 'styled-components'
import { ExploreState } from 'clientPages/explore/types'
import { useExploreColMappingData } from 'cmsHooks'

import { FilterContainer, NameContainer } from './displayComponents'
import ExpandDefinitionsButton from './ExpandDefinitionsButton'
import { addFilter, removeFilter } from './filterOperations'
import CMS from '@talus-analytics/library.airtable-cms'
import StyledTypeaheadControl from 'components/ui/StyledTypeaheadControl'
import TypeaheadResult from 'components/ui/TypeaheadResult'

const getItems = (keys: string[]) => keys.map(key => ({ label: key, key: key }))

const Name = styled.div`
  font-weight: normal;
  text-transform: uppercase;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.text};
`

interface FilterControlProps {
  name: string
  options: string[]
  exploreState: ExploreState
  setExploreState: React.Dispatch<React.SetStateAction<ExploreState>>
}

const FilterControl: React.FC<FilterControlProps> = ({
  name,
  options,
  exploreState,
  setExploreState,
}) => {
  const selectedOptionKeys =
    exploreState.filters?.[name as keyof typeof exploreState.filters]

  const remainingOptionKeys = options.filter(
    option => !selectedOptionKeys?.includes(option)
  )

  const colMappingData = useExploreColMappingData()
  return (
    <FilterContainer>
      <NameContainer expanded={exploreState.defs === name}>
        {/* Map col names from Airtable to desired display name */}
        <Name>{CMS.getText(colMappingData, name.replace(/_/g, ' '))}</Name>
        {/* <ExpandDefinitionsButton {...{ name, exploreState, setExploreState }} /> */}
      </NameContainer>
      <StyledTypeaheadControl
        itemsSelected={
          (selectedOptionKeys && selectedOptionKeys?.length > 0) || false
        }
        multiselect
        ariaLabel={name.replace(/_/g, ' ') + ' filter search'}
        placeholder={`${selectedOptionKeys?.length ?? 0} of ${options.length}`}
        items={getItems(remainingOptionKeys)}
        values={getItems(selectedOptionKeys ?? [])}
        onAdd={item => addFilter({ [name]: [item.label] }, setExploreState)}
        onRemove={item =>
          removeFilter({ [name]: [item.label] }, setExploreState)
        }
        RenderItem={({ item: { label } }) => (
          <TypeaheadResult>{label}</TypeaheadResult>
        )}
      />
    </FilterContainer>
  )
}

export default FilterControl
